import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import GridCardList from './components/GridCardList';
import Pagination from '@material-ui/lab/Pagination';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import { getAllOpportunity } from '../../serviceAPI/opportunity/getAllOpportunity'
import { getOpportunityByName } from '../../serviceAPI/opportunity/getOpportunityByName';
import { Typography } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  pagination: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  input: {
    marginLeft: theme.spacing(1)
  },
  iconButton: {
    padding: 10,
  },
}));

function ConsultaVagas() {
  const classes = useStyles();
  const dispatch = useDispatch()
  const [nomeVaga, setNomeVaga] = React.useState('');
  const [getAllBefore, setGetAllBefore] = React.useState(true);

  const vagas = useSelector(state => state.opportunity.opportunities)
  vagas.sort(function (a, b) {
    return a.title < b.title ? -1 : a.title > b.title ? 1 : 0;
  });
  const [countPage, setCountPage] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [vagasPaginadas, setVagasPaginadas] = React.useState([]);


  const pageChange = (event, value) => {
    setPage(value)
    const firstValue = (6 * (value - 1));
    const lastValue = (6 * value);
    setVagasPaginadas(vagas.slice(firstValue, lastValue));
  };

  React.useEffect(() => {
    getAllOpportunity(dispatch);
  }, []);

  React.useEffect(() => {
    const totalPages = Math.ceil(vagas.length / 6)
    setCountPage(totalPages)
    setVagasPaginadas(vagas.slice(0, 6));
  }, [vagas]);

  async function buscarVagas(nomeVaga) {
    await getOpportunityByName(nomeVaga, dispatch)
    setPage(1)
  }

  onsubmit = (event) => {
    event.preventDefault()
    if (nomeVaga !== "") {
      buscarVagas(nomeVaga)
      setGetAllBefore(false)
    } else if (!getAllBefore) {
      getAllOpportunity(dispatch);
      setPage(1)
      setGetAllBefore(true)
    }
  }

  return (
    <div>
      <Container component="main" maxWidth="xl">

        <Grid justify="flex-end" container>
          <form>
            <TextField
              fullWidth
              className={classes.searchField}
              id="input-with-icon-textfield"
              label="Pesquisar por nome"
              variant="outlined"
              value={nomeVaga}
              onChange={(e) => setNomeVaga(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={onsubmit}>
                      <SearchIcon />
                    </IconButton>

                  </InputAdornment>
                ),
              }}
            />
          </form>
        </Grid>
        <GridCardList
          vagasPaginadas={vagasPaginadas}
        />
        {vagas.length === 0 ?
          <Grid alignItems="center" justify="center" container>
            <Typography>
              Nenhuma vaga disponivel no momento
            </Typography>
          </Grid>
          :
          <Box display="flex" justifyContent="center">
            <Pagination
              className={classes.pagination}
              count={countPage}
              color="primary"
              onChange={pageChange}
              page={page}
            />

          </Box>
        }

      </Container>

    </div>
  )

}

export default ConsultaVagas;